import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@zrsystem/ui';
import { useMemo, type ReactNode } from 'react';

import { AuthProvider } from '@/app/providers/auth-provider.js';
import { SurfaceProviders } from '@/app/providers/surface-providers.js';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1,
          },
        },
      }),
    [],
  );

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <SurfaceProviders>{children}</SurfaceProviders>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
